import { render, staticRenderFns } from "./improve.vue?vue&type=template&id=6c0db71e&scoped=true"
import script from "./improve.vue?vue&type=script&lang=js"
export * from "./improve.vue?vue&type=script&lang=js"
import style0 from "./improve.vue?vue&type=style&index=0&id=6c0db71e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0db71e",
  null
  
)

export default component.exports